/** 1–5 star rating; tapping the current value clears it. Colours come from CSS tokens so dark mode works. */
export function Stars(props: { value: number; onChange: (v: number) => void }) {
  return (
    <div class="stars" role="radiogroup" aria-label="Rating">
      <span class="hint" style={{ marginRight: 8, fontWeight: 500 }}>Rating</span>
      {[1, 2, 3, 4, 5].map((v) => (
        <button key={v} type="button" class="star ghost" role="radio" aria-checked={props.value >= v}
                aria-label={`${v} star${v > 1 ? "s" : ""}`} onClick={() => props.onChange(props.value === v ? 0 : v)}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path class={props.value >= v ? "on" : "off"} d="M12 2.5l2.95 6.26 6.85.84-5.05 4.73 1.3 6.8L12 17.77l-6.05 3.36 1.3-6.8L2.2 9.6l6.85-.84L12 2.5z" />
          </svg>
        </button>
      ))}
    </div>
  );
}
